import { STATUS, TournamentEvent } from "../types/types";
import { Card, CardActionArea, CardContent } from "@mui/material";
import { formatTime2 } from "../utils";

interface Props {
    onClick?: (eventId: string) => void;
    event: TournamentEvent;
}

function TournamentEventComponent(props: Props) {
    const { event, onClick } = props;

    return (
        <Card
            onClick={() => onClick && onClick(event.id)}
            className={`${event.status} ${event.location.id}`}
            sx={{
                padding: "5px 0px",
                backgroundColor: "transparent",
                boxShadow: "unset",
                opacity:
                    event.status === STATUS.FINISHED ||
                        event.status === STATUS.CANCELLED
                        ? 0.3
                        : 1,
                fontStyle:
                    event.status === STATUS.FINISHED ||
                        event.status === STATUS.CANCELLED
                        ? "italic"
                        : "normal",
            }}
        >
            <CardActionArea>
                <CardContent
                    sx={{
                        fontStyle:
                            event.status === STATUS.FINISHED ||
                                event.status === STATUS.CANCELLED
                                ? "italic"
                                : "normal",
                        padding: 0,
                    }}
                >
                    <div className="match tournament-event">
                        <div
                            className={event.status === STATUS.PLAYING ? "column-0" : ""}
                        ></div>
                        <div className="column-1">
                            {event.status === STATUS.FINISHED
                                ? "FT"
                                : formatTime2(event.startTime + event.location.delay * 60)}
                        </div>
                        <div className="column-2" style={{ gridColumn: "2 / 5" }}>
                            <div className="tournament-event-title">
                                {event.title}
                            </div>
                        </div>
                    </div>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}

export default TournamentEventComponent;
